import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalInfoService } from '../../../core/services/modal-info.service';
import {ModalInfoComponent} from '../modal-info/modal-info.component';

@Component({
  selector: 'modal-info-host',
  standalone: true,
  imports: [CommonModule, ModalInfoComponent],
  template: `
    <modal-info
      *ngIf="vm().show"
      [title]="vm().title"
      (close)="close()"
    >
      <div *ngIf="vm().images.length" class="modal-info-images">
        <img
          *ngFor="let img of vm().images"
          [src]="img"
          alt="Información"
        />
      </div>

      <p *ngFor="let msg of vm().messages">
        <strong *ngIf="msg.bold">{{ msg.text }}</strong>
        <span *ngIf="!msg.bold">{{ msg.text }}</span>
      </p>
    </modal-info>
  `,
})
export class ModalInfoHostComponent {
  private readonly modal = inject(ModalInfoService);

  readonly vm = computed(() => this.modal.state());

  close(): void {
    this.modal.close();
  }
}
